<template>

    <v-page-section padded>
        <template #body>

            <v-notice v-if="affiliate" title="Get 30% Commission">
                <template #body>
                    <h4>Get 30% Commission</h4>
                    <p>Behold! Your unique referral link!<br>Earn 30% commission every month for each paying customer you bring in.</p>
                    <p class="text-primary"><strong>{{ affiliate.links[0].url }}</strong></p>
                </template>
                <template #footer>
                    <v-button-toolbar>
                        <v-button @click.native="shareOnLinkedIn" btn-style="linkedin">
                            <span><i class="fa-brands fa-linkedin mr-5"></i>Share on LinkedIn</span>
                        </v-button>
                        <v-button @click.native="shareOnTwitter" btn-style="twitter">
                            <span><i class="fa-brands fa-twitter mr-5"></i>Share on Twitter</span>
                        </v-button>
                        <v-button @click.native="copyLink">
                            <span><i class="fa-solid fa-link mr-5"></i>Copy Link</span>
                        </v-button>
                    </v-button-toolbar>
                </template>
            </v-notice>

            <v-notice class="header" v-else>
                <template #body>
                    <h4>Get 30% Commission</h4>
                    <p>Get your unique referral link!<br>Earn 30% commission every month for each paying customer you bring in.</p>
                    <p class="text-primary"><strong>https://crowdpower.io?via=[YOUR_ID]</strong></p>
                </template>
            </v-notice>

        </template>
    </v-page-section>

</template>

<style scoped lang="scss">

    .header {
        @include font-semibold(14px);
    }

</style>

<script>

export default {

    props: {
        affiliate: {
            type: Object,
        },
    },

    data() {
        return {
            share: 'I’m using CrowdPower to grow my SaaS, and you should too.',
            url: this.affiliate ? this.affiliate.links[0].url : '',
        }
    },

    methods: {

        shareOnLinkedIn() {
            const text = encodeURIComponent(this.share);
            const url = encodeURIComponent(this.url);
            const link = `http://linkedin.com/share?text=${text}&url=${url}`;
            window.open(link, '_blank');
        },

        shareOnTwitter() {
            const text = encodeURIComponent(this.share);
            const url = encodeURIComponent(this.url);
            const link = `http://twitter.com/share?text=${text}&url=${url}&hashtags=crowdpower`;
            window.open(link, '_blank');
        },

        copyLink() {
            navigator.clipboard.writeText(this.url)
                .then(() => {
                    this.$store.commit('setAlertSuccess', this.$t('message.copied'));
                    this.copied = true;
                })
                .catch(() => {
                    this.$store.commit('setAlertError', 'Unable to copy text.');
                });
        },

    },

}

</script>